import React, {useEffect, useState} from 'react';
import {Table} from "antd";
import {joinData, mapTableHeader} from "../Installations/tableHelperFuntions";
import api from "../../api/apiInterceptor";
import {useDispatch, useSelector} from "react-redux";
import {getLocations, getUserInfo, installationSelect, reloadTableView} from "../../redux-store/selectors";
import {reloadedTableView} from "../../redux-store/globalData";
import SearchComponent from "../SearchComponent";
import {checkUserViewer} from "../authHelpers";
import TableDownloadButton from './TableDownloadButton';


function InstallationTable({id}) {

    const [tableHeader, setTableHeader] = useState([])
    const [tableName, setTableName] = useState([])
    const [tableData, setTableData] = useState([])
    const [filteredTableData, setFilteredTableData] = useState([])
    const [loader, setLoader] = useState(false)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    const userInfo = useSelector(getUserInfo)
    const reloadTable = useSelector(reloadTableView)
    const locations = useSelector(getLocations);
    const installationSelectValue = useSelector(installationSelect)

    const dispatch = useDispatch()

    const fetchTableData = async (pag = pagination) => {
        setLoader(true)
        let tableResult = await api.get(`/api/installations/${installationSelectValue.value}/tableviews/${id}?page=${pag.current - 1}&size=${pag.pageSize}`)
        setPagination({
            ...pag,
            total: tableResult.data.numRows,
            pageSizeOptions: ["10", "20", "30", tableResult.data.numRows],
            showSizeChanger: true,
        })
        let headerResult = mapTableHeader(tableResult.data, checkUserViewer(userInfo))
        setTableHeader(headerResult.filter((item) => item !== undefined))
        setLoader(false)
        const tableDataResult = joinData(tableResult.data, locations, headerResult)
        setTableData(tableDataResult)
        setFilteredTableData(tableDataResult)
        setTableName(tableResult.data.name)
    }

    const handleTableChange = (newPagination, filters, sorter) => {
        fetchTableData(newPagination, filters, sorter)
    }


    useEffect(() => {
        if (reloadTable) {
            fetchTableData().then(() => dispatch(reloadedTableView()))
        }
    }, [reloadTable])

    useEffect(() => {
        if(locations.length){
            fetchTableData()
        }
    }, [id, locations])

    const handleSearch = (searchVal) => {
        if (searchVal) {
            let test = []
            tableData.forEach((row) => {
                for (const cell in row) {
                    if (row[cell].value) {
                        if (row[cell].value.toString().toLowerCase().includes(searchVal.toLowerCase())) {
                            test.push(row)
                        }
                    }
                }
            })
            setFilteredTableData(test)
        } else {
            setFilteredTableData(tableData)
        }
    }

    return (
        <>
            <div className={"row pt-3"}>
                <h5 style={{fontWeight: 'bolder'}}>{tableName}</h5>
                <div className={"col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"}>
                    <SearchComponent handleSearchSubmit={handleSearch}/>
                </div>
            </div>
            <Table showSorterTooltip={false} columns={tableHeader} dataSource={filteredTableData} size="small"
                   scroll={{
                    x: 900,
                    //y: 450,
                   }}
                   rowKey={record => record.location.id}
                   loading={loader}
                   pagination={pagination}
                   onChange={handleTableChange}
            />
            <TableDownloadButton installationId={installationSelectValue.value} tableId={id} />
        </>
    );
}

export default InstallationTable;